<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  async created() {
    console.log(`STORE status check ${this.resultName}`)
    console.log('this.me', this.me)
    if (!this.me?.store.typeOfBusiness) {
      console.log('스토어 정보가 없어서 리다이렉트')
      const path = '/signup/store'
      if ([path].includes(this.$route.path) === false && this.routerStatusRedirect) {
        this.$router.replace(path)
      }
      return
    }

    console.log('emitNext', this.resultName)
    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
